import {
  FETCH_ATTENDANCE,
  FETCH_ATTENDANCE_SUCCESS,
  FETCH_ATTENDANCE_FAILURE,
  FETCH_ATTENDANCE_LOAD,
  FETCH_ATTENDANCE_LOAD_SUCCESS,
  FETCH_ATTENDANCE_LOAD_FAILURE,
} from "../actions";

const initialState = {
  attendance: [],
  loading: true,
  err: null,
  haveData: false,
  attendancePercentage: "",
  attendanceNextpage: "",
  attendanceTotalPage: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ATTENDANCE:
      return {
        ...state,
        loading: true,
        err: null,
        haveData: false,
        attendance: [],
      };
    case FETCH_ATTENDANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        haveData: true,
        attendance: action.data,
        attendancePercentage: action.data.attendance,
        attendanceNextpage: action.data.next,
        attendanceTotalPage: action.data.total_pages,
      };
    case FETCH_ATTENDANCE_FAILURE:
      return {
        ...state,
        loading: false,
        haveData: false,
        err: action.error,
        attendance: [],
      };
    case FETCH_ATTENDANCE_LOAD:
      return {
        ...state,
      };
    case FETCH_ATTENDANCE_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        haveData: true,
        attendance: action.data,
        attendancePercentage: action.data.attendance,
        attendanceNextpage: action.data.next,
        attendanceTotalPage: action.data.total_pages,
      };
    case FETCH_ATTENDANCE_FAILURE:
      return {
        ...state,
        loading: false,
        haveData: false,
        err: action.error,
        attendance: [],
      };
    default:
      return state;
  }
};
